import { render, staticRenderFns } from "./ExportFileSizesTab.vue?vue&type=template&id=3df0f2ca&scoped=true"
import script from "./ExportFileSizesTab.vue?vue&type=script&lang=js"
export * from "./ExportFileSizesTab.vue?vue&type=script&lang=js"
import style0 from "./ExportFileSizesTab.vue?vue&type=style&index=0&id=3df0f2ca&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df0f2ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3df0f2ca')) {
      api.createRecord('3df0f2ca', component.options)
    } else {
      api.reload('3df0f2ca', component.options)
    }
    module.hot.accept("./ExportFileSizesTab.vue?vue&type=template&id=3df0f2ca&scoped=true", function () {
      api.rerender('3df0f2ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/Export/components/ExportFileSizesTab.vue"
export default component.exports